import * as React from 'react';
import styled, { withTheme } from 'styled-components';
import { rem } from 'polished';
import { __ } from 'react-i18n';

interface Props {
  avail_id: number;
  availability: string;
  bottomMargin?: boolean;
  justify?: string;
  onStockCount?: number;
  isNew?: boolean;
  conditionTextMapping?: any;
  condition?: any;
  isWaiting?: boolean;
}

function StockInfo({
  avail_id,
  availability,
  bottomMargin = false,
  justify = 'initial',
  onStockCount,
  isNew,
  conditionTextMapping,
  condition,
  isWaiting,
}: Props) {
  const isAvailable = avail_id === 1;
  const conditionText =
    conditionTextMapping && condition
      ? conditionTextMapping.find(ctm => ctm.condition == condition)?.text
      : null;
  const availabilityText = conditionText
    ? conditionText
    : isWaiting
    ? __('Na objednávku')
    : !isAvailable && isNew
    ? __('Očakávame')
    : !availability
    ? 'Nedostupné'
    : availability;

  return (
    <StockCount
      justify={justify}
      bottomMargin={bottomMargin}
      available={isAvailable}
      isNew={!!isNew}
      isWaiting={!!isWaiting}
      isCondition={!!conditionText}
    >
      {availabilityText}{' '}
      {onStockCount && onStockCount > 0 ? ` - ${onStockCount} ks` : ''}
    </StockCount>
  );
}

const StockCount = styled.span<{
  available: boolean;
  bottomMargin: boolean;
  justify: string;
  isNew: boolean;
  isWaiting: boolean;
  isCondition: boolean;
}>`
  display: flex;
  align-items: center;
  font-size: ${rem(16)};
  color: ${({ theme, available, isNew, isCondition, isWaiting }) =>
    isWaiting
      ? theme.colors.stockCountExpecting
      : available
      ? isCondition
        ? theme.colors.stockCountCondition
        : theme.colors.stockCountAvailable
      : isNew
      ? theme.colors.stockCountExpecting
      : theme.colors.stockCountSold};
  font-family: ${({ theme }) => theme.font.primary};
  line-height: ${rem(22)};
  width: 100%;
  text-align: left;
  justify-content: ${({ justify }) => justify};
  margin-bottom: ${({ bottomMargin }) => (bottomMargin ? rem(11) : 0)};
`;

export { StockInfo };
